import { ConstantModel } from "@core/models/outros/constant.model";

export const FINANCIAL_OCCURRENCE_TYPE: ConstantModel[] = [
  {
    id: 1,
    descricao: 'INFORMAÇÃO',
    enum: 'I'
  },
  {
    id: 2,
    descricao: 'RECLAMAÇÃO',
    enum: 'R'
  },
  {
    id: 3,
    descricao: 'SUGESTÃO',
    enum: 'S'
  },
]
